import React, { forwardRef } from 'react';
import { alpha, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { splitByMatches } from '../../utils/searchUtils';
import { useAppSelector } from '../../hooks';
import { getPricingSheetLabelParts } from '../../utils/pricingSheetUtils';
import { PricingSheet } from '../../types/PricingSheet';
import { I18nKeys } from '../../constants/I18nKeys';
import pricingUpchargeIcon from '../../images/pricingUpchargeIcon.svg';
import { ContentList } from '../library/ContentList';
import { SalesViewUILayout } from '../../constants/Viewer';

export const PricingAttributesLabel = forwardRef<
  HTMLUListElement,
  {
    pricingSheet: PricingSheet;
  }
>(({ pricingSheet }, ref) => {
  const { t } = useTranslation();

  const pricingTab = useAppSelector((state) => state.viewer.selectedPricingTabId || '');
  const searchTerm = useAppSelector((state) => state.search.searchTerm);
  const { secondaryMenuItem } = useAppSelector((state) => state?.menu);

  return (
    <ContentList
      items={getPricingSheetLabelParts(pricingSheet, SalesViewUILayout.Horizon, pricingTab, secondaryMenuItem, t).map(
        (label = '') => {
          const displayAsSidingUpcharge = label === t(I18nKeys.PricingSheetAttributeSidingUpcharge);
          return {
            label: (
              <Typography
                ref={ref}
                sx={{
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  WebkitLineClamp: 2,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  ...(displayAsSidingUpcharge ? { color: '#38761E', fontWeight: 'bold' } : {}),
                }}
                variant="body2"
              >
                {splitByMatches(label, searchTerm, {}).map((part, index) => (
                  <Typography
                    component="span"
                    fontSize="14px"
                    color={alpha('#000000', 0.87)}
                    // eslint-disable-next-line react/no-array-index-key
                    key={`${label}-${index}`}
                    style={{ backgroundColor: part.highlight ? '#FDFF80' : undefined }}
                  >
                    {part.text}
                  </Typography>
                ))}
                {displayAsSidingUpcharge && (
                  <img alt="Siding upcharge icon" src={pricingUpchargeIcon} style={{ marginLeft: '5px' }} />
                )}
              </Typography>
            ),
          };
        },
      )}
      listStyleType="disc"
      spacing="0px"
    />
  );
});
